// extracted by mini-css-extract-plugin
export var addButton = "_er-0";
export var border = "_er-8";
export var check = "_er-h";
export var danger = "_er-6";
export var dropdownContainer = "_er-1";
export var editModalBody = "_er-j";
export var footerContainer = "_er-i";
export var fullWidth = "_er-a";
export var hide = "_er-9";
export var icon = "_er-3";
export var input = "_er-7";
export var inputFlex = "_er-b";
export var inputWrapper = "_er-c";
export var manualFocus = "_er-5";
export var optionButton = "_er-4";
export var pillWrapper = "_er-e";
export var pointer = "_er-2";
export var showOverflow = "_er-f";
export var tagsFlex = "_er-d";
export var xButton = "_er-g";